(function() {
'use strict';

angular
    .module('TR')
    .service('advertService', advertService);

function advertService($http, pageStrand) {
    const service = {
        getAdvertsForPosition,
        getUrl
    };

    function getUrl() {
        return `${TRPCONFIG.AdvertImagesClientDomain}/api2/squibs/`;
    }

    function getAdvertsForPosition(positionId, destination) {
        return $http.get(`${TRPCONFIG.AdvertServiceClientDomain}/api2/squibs/getsquibsforposition?${$.param({
            CountryId: destination.CountryId,
            ProvinceId: destination.ProvinceId,
            LocationId: destination.LocationId,
            PlaceId: destination.PlaceId,
            EstablishmentId: destination.EstablishmentId,
            PolygonId: destination.PolygonId,
            PageStrand: pageStrand.fromRoute(destination),
            PositionId: positionId,
            DomainId: TRPCONFIG.Domain.DomainId,
            v: TRPCONFIG.CurrentVersion,
            Domain: location.host
        })}`, { cache: true, ignoreErrors: true }).then(function(res) {
            return res.data;
        });
    }

    return service;
}
})();
